// extracted by mini-css-extract-plugin
export var infoRow = "_mx-2";
export var labelContainer = "_mx-0";
export var rightInfo = "_mx-1";